import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React, { PureComponent } from 'react';
import ReactPaginate from 'react-paginate';
import PropTypes from 'prop-types';

var Pagination =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Pagination, _PureComponent);

  function Pagination() {
    _classCallCheck(this, Pagination);

    return _possibleConstructorReturn(this, _getPrototypeOf(Pagination).apply(this, arguments));
  }

  _createClass(Pagination, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          pagesOutsideElipses = _this$props.pagesOutsideElipses,
          pagesBetweenElipses = _this$props.pagesBetweenElipses,
          rest = _objectWithoutProperties(_this$props, ["pagesOutsideElipses", "pagesBetweenElipses"]);

      return React.createElement(ReactPaginate, _extends({
        marginPagesDisplayed: pagesOutsideElipses,
        pageRangeDisplayed: pagesBetweenElipses,
        previousLabel: '<',
        nextLabel: '>',
        breakLabel: React.createElement("a", null, "...") // eslint-disable-line jsx-a11y/anchor-is-valid
        ,
        containerClassName: "pagination",
        pageClassName: "pageNumber",
        activeClassName: "active pageNumber",
        previousClassName: "arrow",
        nextClassName: "arrow",
        breakClassName: "disabled ellipses"
      }, rest));
    }
  }]);

  return Pagination;
}(PureComponent);

export { Pagination as default };
Pagination.propTypes = {
  initialPage: PropTypes.number,
  pagesOutsideElipses: PropTypes.number,
  pagesBetweenElipses: PropTypes.number
};
Pagination.defaultProps = {
  initialPage: 0,
  pagesOutsideElipses: 1,
  pagesBetweenElipses: 3
};